import { NavLink } from 'react-router-dom';
import { fromUnixTime } from 'date-fns';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import useTranslation from '../../../../../hooks/useTranslations';
import { EditIcon, TrashIcon, DragIcon } from '../../../../misc/icons/Icons';
import { editTitleFavoriteList, openFavoritesDeleteModal } from '../../../../../redux/modules/favoritesSlice';
import Inputfield from '../../../../misc/Inputfield';
import useFormatLocaleDate from '../../../../../hooks/useFormatLocaleDate';

const FavoriteRow = ({
	id, title, created, size, count, hideButtons = false,
}) => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const [isNewTitleInputFieldOpen, setIsNewTitleInputFieldOpen] = useState(false);

	const handleNewTitle = (value) => {
		dispatch(editTitleFavoriteList({ title: value, favoriteListId: id }));
		setIsNewTitleInputFieldOpen(false);
	};

	const handleClick = (e) => {
		if (isNewTitleInputFieldOpen) { e.preventDefault(); }
	};

	const openDeleteModal = () => {
		dispatch(openFavoritesDeleteModal({ favoriteListId: id }));
	};

	return (
		<div className="relative flex items-center justify-between w-full h-24 sm:h-34 can-hover:hover:bg-gray-50">
			<NavLink
				to={`/favorites/${id}`}
				className={`flex flex-col items-start justify-center flex-grow h-full gap-3 pl-4 sm:pl-10 ${!hideButtons ? 'pr-36 sm:pr-56' : 'pr-4 sm:pr-10'} focus:outline-none`}
				onClick={(e) => handleClick(e)}
			>
				{!isNewTitleInputFieldOpen && (
					<span className="font-semibold text-[1.0625rem] py-2 line-clamp-2">
						{title === '' && t('favorite_list_migrated_bookmarks')}
						{title !== '' && title}
					</span>
				)}
				{isNewTitleInputFieldOpen && <Inputfield classes="-ml-3" fieldName="editFavListTitle" label={t('favorite_list_add_alert_input_placeholder')} placeholder={t('favorite_list_add_alert_input_placeholder')} initialValue={title} showCheckmark handleBlur={handleNewTitle} autoFocus />}
				<span className="text-[0.75rem] sm:text-[0.9375rem] text-oly-gray-dark line-clamp-2">
					{useFormatLocaleDate(fromUnixTime(created))}
					{' '}
					•
					{' '}
					{size}
					{' '}
					{count === 1 && t('favorite_list_table_detail_text_asset_singular')}
					{count !== 1 && t('favorite_list_table_detail_text_asset_plural').replace('#assetcount#', count)}
				</span>
			</NavLink>
			<div className="absolute right-0 flex flex-shrink-0 pr-3 sm:gap-6">
				{!hideButtons && (
					<>
						<button
							type="button"
							onClick={() => setIsNewTitleInputFieldOpen(true)}
							className="flex items-center flex-shrink-0 p-2 rounded-lg text-oly-yellow-default can-hover:hover:shadow-button focus-visible:shadow-button focus:outline-none"
							aria-labelledby="edit-favorite-list-title"
						>
							<EditIcon className="w-6 h-6 sm:w-8 sm:h-8" />
						</button>
						<button
							type="button"
							onClick={() => openDeleteModal()}
							className="flex items-center flex-shrink-0 p-2 rounded-lg text-oly-yellow-default can-hover:hover:shadow-button focus-visible:shadow-button focus:outline-none"
							aria-labelledby="delete-favorite-list"
						>
							<TrashIcon className="w-6 h-6 sm:w-8 sm:h-8" />
						</button>
						<div className="flex items-center flex-shrink-0 p-2 rounded-lg drag-control text-oly-gray-darkest">
							<DragIcon className="w-6 h-6 sm:w-8 sm:h-8" />
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default FavoriteRow;
